import { Box, Card, CardContent, Grid, Typography, Button, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PrintIcon from '@mui/icons-material/Print';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PeopleIcon from '@mui/icons-material/People';

const DocumentsPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("global");
    const BASE_PATH = process.env.REACT_APP_BASE_PATH || '';

    const documents = [
        {
            title: "Scheda Uscite Settimanali",
            description: "Registro cartaceo per orari di uscita e rientro degli ospiti",
            icon: <ExitToAppIcon sx={{ fontSize: 60, color: 'primary.main' }} />,
            path: '/documents/weekly-exits',
            color: '#1976d2'
        },
        {
            title: "Scheda Visite Settimanali",
            description: "Registro cartaceo per visite dei parenti",
            icon: <PeopleIcon sx={{ fontSize: 60, color: 'success.main' }} />,
            path: '/documents/weekly-visits',
            color: '#2e7d32'
        }
    ];

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3
            }}
        >
            <Toolbar />
            
            <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
                <PrintIcon sx={{ mr: 2, verticalAlign: 'middle' }} />
                Documenti Stampabili
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Genera e stampa registri cartacei per la gestione quotidiana della struttura
            </Typography>

            <Grid container spacing={3}>
                {documents.map((doc, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card 
                            sx={{ 
                                height: '100%',
                                cursor: 'pointer',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 4
                                }
                            }}
                            onClick={() => navigate(`${BASE_PATH}${doc.path}`)}
                        >
                            <CardContent sx={{ textAlign: 'center', p: 4 }}>
                                <Box sx={{ mb: 2 }}>
                                    {doc.icon}
                                </Box>
                                
                                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                                    {doc.title}
                                </Typography>
                                
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                    {doc.description}
                                </Typography>
                                
                                <Button 
                                    variant="contained" 
                                    startIcon={<PrintIcon />}
                                    sx={{ 
                                        backgroundColor: doc.color,
                                        '&:hover': {
                                            backgroundColor: doc.color,
                                            filter: 'brightness(0.9)'
                                        }
                                    }}
                                >
                                    Genera Documento
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Istruzioni */}
            <Box sx={{ mt: 4, p: 3, backgroundColor: 'background.paper', borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>
                    ℹ️ Come utilizzare
                </Typography>
                <Typography variant="body2" component="div">
                    <ul style={{ paddingLeft: '20px' }}>
                        <li>Seleziona il tipo di documento da generare</li>
                        <li>Scegli la settimana di riferimento</li>
                        <li>Il documento verrà generato in formato PDF pronto per la stampa</li>
                        <li>Stampa e compila manualmente durante la settimana</li>
                    </ul>
                </Typography>
            </Box>
        </Box>
    );
};

export default DocumentsPage;
